import React from 'react'
import { Box, Button, Heading } from '@chakra-ui/react'

const EmptyCards = ({
  accentColor,
  dictionary,
  fontFamily,
  handleApiConnection,
}) => {
  return (
    <Box
      w='100%'
      h='auto'
      display='flex'
      alignItems='center'
      justifyContent='center'
      textAlign='center'
      flexDirection='column'
      p='7rem 0rem'
    >
      <Heading
        color={accentColor}
        m='0'
        pt='1rem'
        fontSize={['3xl', '4xl', '4xl', '5xl']}
        fontFamily={fontFamily}
        fontWeight='700'
      >
        {dictionary.EMPTY.title}
      </Heading>
      <Box pt='2rem' w='100%'>
        <Button
          shadow='lg'
          size='lg'
          bg={accentColor}
          colorScheme='blue'
          color='white'
          _hover={{
            bg: accentColor,
            transform: 'scale(1.05)'
          }}
          _active={{
            bg: accentColor,
            transform: 'scale(0.95)'
          }}
          onClick={() => {
            handleApiConnection()
          }}
        >
          <Heading
            m='px'
            fontSize={['sm', 'sm', 'md', 'md']}
            fontFamily={fontFamily}
            fontWeight='700'
          >
            {dictionary.EMPTY.cta}
          </Heading>
        </Button>
      </Box>
    </Box>
  )
}

export default EmptyCards
